import { Link } from "gatsby";
import React, { useState } from "react";
import FreeQuotesModal from "../FreeQuotesModal";
const CallToAction = ({
  text,
  desc,
  descLink,
  buttonText,
  isIndexPage,
  otherPage,
  careerPage,
  buttonLink,
  inSiteRedirect = false,
  ctaLink,
  isButton = false,
  onButtonClick,
  isExternalLink = false,
  isQuoteModal = false,
}) => {
  const commonButtonProps = {
    className:
      "justify-center px-10 pt-2.5 pb-2.5 my-auto sm:text-lg text-base font-medium text-center text-white bg-primary rounded-md",
  };
  const [openFreeQuotesModal, setOpenFreeQuotesModal] = useState(false);
  return (
    <section
      className={`flex gap-5 justify-between max-md:flex-wrap lg:pt-[100px] sm:pt-16 pt-12 lg:pb-[100px] sm:pb-16 pb-12 lg:px-7 px-5 ${
        isIndexPage ? "bg-white" : "bg-gray-100"
      }`}
    >
      <div className="container max-w-7xl mx-auto">
        <div className="flex lg:flex-row flex-col justify-between items-center gap-5">
          <div className="max-md:max-w-full flex flex-col">
            <h2 className="lg:text-[44px] lg:leading-[57px] leading-tight sm:text-[40px] text-3xl font-semibold text-gray-900 lg:text-start text-center max-w-[800px]">
              {text}
            </h2>
            <div className="inline font-normal lg:text-2xl sm:text-xl text-lg text-gray-700 lg:text-start text-center !leading-relaxed pt-3">
              <p className={`inline ${otherPage ? "hidden" : ""}`}>{desc}</p>
              {isExternalLink ? (
                <a
                  href={ctaLink}
                  className={`text-gray-900 font-semibold ms-2 ${careerPage ? "inline" : "hidden"}`}
                >
                  {descLink}
                </a>
              ) : (
                <Link
                  to={ctaLink ?? "/contact-us"}
                  className={`text-gray-900 font-semibold ms-2 ${careerPage ? "inline" : "hidden"}`}
                >
                  {descLink}
                </Link>
              )}
            </div>
          </div>

          {isButton ? (
            <button onClick={onButtonClick} {...commonButtonProps}>
              {buttonText}
            </button>
          ) : inSiteRedirect ? (
            <Link to={buttonLink} {...commonButtonProps}>
              {buttonText}
            </Link>
          ) : isQuoteModal ? (
            <button onClick={e => setOpenFreeQuotesModal(true)} {...commonButtonProps}>
              {buttonText}
            </button>
          ) : (
            <a href={buttonLink || "/"} rel="noreferrer" target="_blank" {...commonButtonProps}>
              {buttonText}
            </a>
          )}
        </div>
      </div>
      {openFreeQuotesModal && <FreeQuotesModal onClose={() => setOpenFreeQuotesModal(false)} />}
    </section>
  );
};

export default CallToAction;
